


























































































import Vue from 'vue';
import HigheredLogo from '~/assets/img/HigheredLogo.svg';
import localization from '~/localization';
import {
    HAS_ASSESSMENTS,
    HAS_COURSERA,
    HAS_DOCUMENTS,
    HAS_MASTERCLASSES,
    HAS_MY_PROFILE,
    HAS_VFAIRS,
    SHOW_COMPANIES,
    SHOW_JOBS,
    SHOW_PROFILE_BANNER,
    SHOW_UNIVERSITY_BADGES,
} from '~/router';
import { User } from '~/services/IdentityService';
import SchoolService from '~/services/SchoolService';
import UniversityBadges from '~/shared/universitybadges/UniversityBadges.vue';
import URLS from '~/URLS';
import OrgLogo from '../../config/LOGO.png';
import LocaleDropdown from './LocaleDropdown.vue';
import NavigationDropdown, { NavDropdownItem } from './NavigationDropdown.vue';
import NavLink from './NavLink.vue';
import ProfileNavigation from './ProfileNavigation.vue';

export default Vue.extend({
    name: 'Navigation',
    components: {
        LocaleDropdown,
        NavLink,
        NavigationDropdown,
        ProfileNavigation,
        UniversityBadges,
    },
    props: {
        value: Boolean,
    },
    data() {
        return {
            higheredLogo: HigheredLogo,
            orgLogo: OrgLogo,

            shadow: window.scrollY > 0,
            dropdownTop: 0,

            showProfileNav: false,
            showProfileBanner: SHOW_PROFILE_BANNER,
            showUniversityBadges: SHOW_UNIVERSITY_BADGES,

            urlMatches: {
                jobMatches: [URLS.findjobs, URLS.jobDetail],
                eventMatches: [URLS.vfairs, URLS.vfair],
                resourceMatches: [
                    URLS.resources,
                    URLS.internalResources,
                    URLS.assessments,
                    URLS.coursera,
                    URLS.calendar,
                    URLS.plansAndBilling,
                    URLS.favorites,
                ],
            },
        };
    },
    computed: {
        urls(): Record<string, string | null> {
            const urls: typeof URLS = (this as any).$URLS;
            const v = (cond: boolean, url: string) => (!cond ? null : url);

            return {
                myProfile: v(HAS_MY_PROFILE, urls.spotlight),
                findJobs: v(SHOW_JOBS, urls.findjobs),
                companies: v(SHOW_COMPANIES, urls.findcompanies),
                events: v(HAS_VFAIRS, urls.vfairs),

                masterclasses: v(HAS_MASTERCLASSES, urls.resources),
                resources: v(HAS_DOCUMENTS, urls.internalResources),
                assessments: v(HAS_ASSESSMENTS, urls.assessments.concat(urls.assessmentCenter)),
                calendar: v(this.hasCalendar, urls.calendar.concat(urls.book)),
                upskill: v(HAS_COURSERA, urls.coursera),
                cvReview: v(true, 'https://gethighered.com/'),
                blog: v(true, 'https://highered.global/blog/'),
            };
        },
        dropdownItems(): NavDropdownItem[] {
            const t = (id: string) => this.$t(`components.navigation.navigation.${id}`).toString();
            return [
                {
                    to: this.urls.masterclasses,
                    label: t('resources'),
                    info: t('info.resources'),
                    icon: ['fal', 'video-plus'],
                    exact: true,
                },
                {
                    to: this.urls.resources,
                    label: t('tools'),
                    info: t('info.tools'),
                    icon: ['fal', 'file'],
                },
                {
                    to: this.urls.assessments,
                    label: t('assessments'),
                    info: t('info.assessments'),
                    icon: ['fal', 'list-check'],
                },
                {
                    to: this.urls.upskill,
                    label: t('coursera'),
                    info: t('info.coursera'),
                    icon: ['fal', 'file-certificate'],
                },
                {
                    to: this.urls.calendar,
                    label: t('calendar'),
                    info: t('info.calendar'),
                    icon: ['fal', 'calendar'],
                },
                /* {
                    to: this.urls.cvReview,
                    label: t('cvReview'),
                    info: t('info.cvReview'),
                    icon: ['fal', 'star'],
                    external: true,
                }, */
                {
                    to: this.urls.blog,
                    label: t('blog'),
                    info: t('info.blog'),
                    icon: ['fal', 'blog'],
                    external: true,
                },
            ];
        },

        isAuthenticated(): boolean {
            return (this as any).$interfaces.logInModule.isLoggedIn();
        },
        user(): User | null {
            return this.$store.getters['profileModule/getUser']();
        },
        firstLetterInName(): string {
            return this.user ? this.user.firstLetterInName : '';
        },
        hasVFairs(): boolean {
            return this.$interfaces.vfairModule.getHasVFairs(HAS_VFAIRS);
        },
        hasCalendar(): boolean {
            return this.$store.getters['misc/getHasAccessToCalendar']();
        },
    },
    methods: {
        handleToggleSidebar() {
            this.$emit('input', !this.$props.value);
        },
        handleScroll() {
            this.shadow = window.scrollY > 0;
        },
        initializeCMSSecret() {
            // Easter Egg functionality. On Ctrl-Alt-C => Open HigheredCMS
            window.addEventListener('keydown', async event => {
                if (event.altKey && event.ctrlKey && event.keyCode === 67) {
                    const schoolId = SchoolService.getCurrentSchoolId();
                    if (schoolId !== null) {
                        window.open(`https://higheredcms.com/edit-school/${schoolId}`);
                    }
                }
            });
        },
    },
    mounted() {
        const el = this.$refs['wrapper'] as Element;
        if (Array.isArray(el)) return;

        this.dropdownTop = el.getBoundingClientRect().height;

        window.addEventListener('scroll', this.handleScroll);

        this.initializeCMSSecret();
        if (localization.isSchoolPlatform) {
            this.$interfaces.vfairModule.setHasVFairs(true);
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
});
